<template>
  <!-- 订单管理 -->
  <div class="insuredOrder main-container">
    <div class="content">
      <div class="search-box btn3">
        <div class="input-item">
          <span class="label">保单号</span>
          <Input v-model="searchParams.policyNo" placeholder="请输入" clearable />
        </div>
        <div class="input-item">
          <span class="label">产品</span>
          <Input v-model="searchParams.productName" placeholder="请输入" clearable />
        </div>
        <div class="input-item">
          <span class="label">出单机构/团队</span>
          <selectTree type="1" v-model="searchParams.applyOrgId" @change="selectTreeChange"></selectTree>
        </div>
        <div class="input-item">
          <span class="label">出单业务员</span>
          <Input v-model="searchParams.salesmanName" placeholder="请输入" clearable />
        </div>
        <div class="input-item">
          <span class="label">质检状态</span>
          <Select v-model="searchParams.qualityStatusList" :transfer="true" clearable multiple>
            <Option value="0">待质检</Option>
            <Option value="1">质检成功</Option>
            <Option value="-1">质检失败</Option>
          </Select>
        </div>
        <div class="input-item" v-if="$units.isOkBao() || $units.isRYBB()">
          <span class="label">销售支持</span>
          <Select v-model="searchParams.salesSupportId" clearable filterable>
            <Option v-for="(item, i) in salesSupportList" :key="i" :value="item.id" :label="item.name"></Option>
          </Select>
        </div>
        <div class="input-item select-two">
          <Select v-model="searchParams.userType" :transfer="true">
            <Option value="1">投保人</Option>
            <Option value="2">被保险人</Option>
          </Select>
          <Input v-model="searchParams.name" placeholder="姓名/手机号" clearable />
        </div>
        <div class="btn-item">
          <Button type="primary" @click="searchAjax()">搜索</Button>
          <Button type="primary" ghost @click="resetSearch()">重置</Button>
          <Button type="primary" ghost @click="exportData()">导出</Button>
        </div>
      </div>

      <Tabs v-model="searchParams.policyType" @on-click="searchAjax()">
        <TabPane label="个险" name="1" />
        <TabPane label="团险" name="2" />
      </Tabs>

      <div class="table-box">
        <loading :isShow="listLoading" />
        <Table :columns="columns" :data="tableData" v-if="tableData.length">
          <template slot-scope="{ row }" slot="policyNo">
            <a class="table-btn" @click.stop="openDetail(row)">{{ row.policyNo }}</a>
          </template>
          <template slot-scope="{ row }" slot="wechatRecord">
            <div>
              <a href="javascript:;" @click="getChat(row, 2)">查看成交</a><span style="display:inline-block; padding: 0 4px;">/</span
              ><a href="javascript:;" @click="getChat(row, 1)">查看实时</a>
            </div>
          </template>
          <template slot-scope="{ row }" slot="qualityStatus">
            <span v-if="row.qualityStatus === 0">待质检</span>
            <span v-else-if="row.qualityStatus === 1">质检成功</span>
            <span v-else-if="row.qualityStatus === -1">质检失败</span>
            <span v-else>-</span>
            <Poptip trigger="hover" transfer-class-name="my-poptip left0" :transfer="true">
              <Icon style="color: #a8adb7; margin-left: 4px" type="md-help-circle" v-if="row.qualityStatus === -1 && row.remark" />
              <div slot="content">
                <p>{{ row.remark }}</p>
              </div>
            </Poptip>
          </template>
          <template slot-scope="{ row }" slot="signStatus">
            <span v-if="row.signStatus * 1 === 0">未签单</span>
            <span v-else-if="row.signStatus * 1 === 1">已签单</span>
          </template>
          <template slot-scope="{ row }" slot="action">
            <template v-if="row.signStatus * 1 === 1">
              <span class="table-btn" @click="handlePass(row)">通过</span>
              <span class="table-btn" @click="handleFail(row)">不通过</span>
            </template>
            <template v-else>
              <span class="table-btn table-btn-disabled">通过</span>
              <span class="table-btn table-btn-disabled">不通过</span>
            </template>
          </template>
        </Table>
        <no-data v-else style="margin-top: 250px"></no-data>
        <Page :total="total" :current="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center" v-if="tableData.length" />
      </div>
      <!-- 线上保单详情  -->
      <detail-modal ref="detailModal"></detail-modal>

      <!-- 线下保单详情 -->
      <policyDetail ref="policyDetailRef"></policyDetail>

      <!-- 不通过表单 -->
      <Modal v-model="isShowFailModal" :loading="failModalLoading" title="备注" width="430" @on-ok="submitQuality">
        <div style="padding-right: 20px;">
          <Form ref="FailForm" :model="failFormData" :label-width="60">
            <FormItem label="备注" prop="remark">
              <Input v-model="failFormData.remark" type="textarea" :rows="4" placeholder="请输入" />
            </FormItem>
          </Form>
        </div>
      </Modal>
    </div>
  </div>
</template>

<script>
import { pageTool, common } from '@/api/mixins';
import userPoptip from '@/components/commons/userPoptip';
import selectTree from '@/components/system/selectTree3';
import { config } from './index.config.js';
import detailModal from '@/pages/orderManage/insuredOrder/components/detailModal';
import policyDetail from '@/pages/orderManage/insuredOrder/components/policyDetail';

export default {
  components: {
    userPoptip,
    detailModal,
    policyDetail,
    selectTree
  },
  mixins: [pageTool, common, config],
  props: {},
  data() {
    return {
      searchParams: {
        policyType: '1',
        userType: '1',
        qualityStatusList: ['0']
      },

      isShowFailModal: false,
      failFormData: {
        remark: ''
      },
      failModalLoading: true
    };
  },
  mounted() {
    this.initListAjax('/buz/policy/sign/list');
    if (this.$units.isOkBao() || this.$units.isRYBB()) {
      this.getOkBaoSalesSupport();
    }
  },
  activated() {
    this.getList();
  },
  methods: {
    getChat(row, t) {
      this.$http({
        type: 'GET',
        url: '/buz/policy/sign/getChat',
        data: {
          policyNo: row.policyNo,
          policyType: this.searchParams.policyType, // 1 个险 2团险
          type: t // 1 实时记录 2成交记录
        }
      }).then(res => {
        if (res.data) {
          window.open(res.data, '_blank');
        } else {
          this.$Message.warning('暂无记录');
        }
      });
    },
    submitQuality(t = -1) {
      this.isShowFailModal = false;
      this.$http({
        type: 'POST',
        url: '/buz/policy/sign/quality',
        data: {
          policyNo: this._currData.policyNo,
          policyType: this.searchParams.policyType, // 1 个险 2团险
          qualityStatus: t, // 1质检成功 -1质检失败
          remark: t === -1 ? this.failFormData.remark : ''
        }
      }).then(res => {
        console.log('res', res);
        this.$notice.msg('操作成功');
        this.getList();
      });
    },
    handlePass(row) {
      this._currData = row;
      this.$Modal.confirm({
        title: '提示',
        content: '确认通过此记录',
        onOk: () => {
          this.submitQuality(1);
        }
      });
    },
    handleFail(row) {
      this._currData = row;
      this.isShowFailModal = true;
    },
    // 获取个险、团险销售支持
    getOkBaoSalesSupport() {
      this.$http({
        url: '/buz/userBase/okbao/getSalesSupport',
        type: 'GET',
        data: {
          type: 1
        }
      }).then(res => {
        if (res.data) {
          this.salesSupportList = res.data;
        }
      });
    },
    setReqParams(params) {
      params.apiPermissionCode = 'order_1_61_0';
    },
    // 转化参数
    setListParams(params) {
      this.getColumns(); //获取表格字段
      if (params.userType == 1) {
        //投保人
        params.holderName = params.name;
      } else if (params.userType == 2) {
        //被保险人
        params.insuranceName = params.name;
      }
      // if (params.qualityStatusList && params.qualityStatusList.length) {
      //   params.qualityStatusList = params.qualityStatusList.join(',');
      // }
      delete params.applyOrgId;
    },
    exportData() {
      const params = JSON.parse(JSON.stringify(this.searchParams));
      this.setListParams(params);
      this.$units.downloadFile('/buz/policy/sign/export', params, 'POST');
    },
    // 组织选择
    selectTreeChange(data) {
      if (data.nodeType == 1) {
        //机构
        this.searchParams.orgId = data.id;
        this.searchParams.groupId = '';
      } else if (data.nodeType == 2) {
        //团队
        this.searchParams.orgId = '';
        this.searchParams.groupId = data.id;
      } else {
        this.searchParams.orgId = '';
        this.searchParams.groupId = '';
      }
    },
    openDetail(row) {
      if (this.searchParams.policyType == 1) {
        if (row.sourceType == 1) {
          console.log('线上');
          this.$refs.detailModal.open(row);
        } else {
          console.log('线下');
          this.$refs.policyDetailRef.open(row);
        }
      } else if (this.searchParams.policyType == 2) {
        this.$router.push({
          path: '/orderManage/group/policyDetail',
          query: {
            id: row.id || '',
            policyNo: row.policyNo,
            orderNo: row.orderNo
          }
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.table-btn-disabled {
  cursor: no-drop;
  color: #c5c8ce;
}
</style>
